import React from "react";
import { PlayerAvatar } from "../PlayerAvatar";

// Scoring summary card — lineup-card look: grey strip (logo · period · time · score), then scorer + goal #, then assists.
export function GoalCard({ g, c, logo, per, time, photo, i }) {
    const cell = "px-1.5 text-[10px] font-black uppercase tracking-wider text-white/70 tabular-nums";
    return (
        <div className="rounded-lg border overflow-hidden min-w-0" style={{ background: `linear-gradient(180deg, ${c}55, ${c}22)`, borderColor: `${c}AA` }} data-testid={`nhl-gc-goal-${i}`}>
            <div className="flex items-center divide-x divide-white/15 bg-white/10 py-1" data-testid={`nhl-gc-goal-head-${i}`}>
                <span className="px-1.5 shrink-0">{logo ? <img src={logo} alt={g.team} className="h-4 w-4 object-contain" /> : <span className="text-[10px] font-black text-white/70">{g.team}</span>}</span>
                <span className={cell}>{per}</span>
                <span className={cell}>{time}</span>
                <span className={`${cell} ml-auto text-white`}>{g.away_score}-{g.home_score}</span>
            </div>
            <div className="flex items-center gap-2 px-2 pt-1.5">
                <PlayerAvatar photo={photo} name={g.scorer} sizePx={36} showTierRing={false} />
                <div className="min-w-0 flex-1">
                    <div className="text-[12px] font-black text-white leading-tight truncate">{g.scorer}</div>
                    <div className="flex items-center gap-1 mt-0.5">
                        {g.scorer_total != null && <span className="text-[9px] font-black uppercase tracking-wider text-white/60">Goal #{g.scorer_total}</span>}
                        {g.strength && g.strength !== "EV" && <span className="text-[9px] font-black px-1 rounded bg-white/15 text-white/85">{g.strength}</span>}
                    </div>
                </div>
            </div>
            <div className="px-2 pt-1 pb-1.5 text-[10px] leading-tight text-white/60 truncate" title={g.assists.join(" | ")}>
                {g.assists.length ? <>Assists by: <span className="text-white/85 font-semibold">{g.assists.join(" | ")}</span></> : "Unassisted"}
            </div>
        </div>
    );
}
